module.exports = __webpack_public_path__ + "OpenSans-Bold.0b381610df444c3b25cb.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/OpenSans-Bold.eot
// module id = ../../../../../src/assets/customfonts/OpenSans-Bold.eot
// module chunks = styles